import React from 'react';

import {
  Typography,
  Box,
  TextFieldProps,
  InputAdornment,
  TextField,
} from '@mui/material';
import { FormikProps } from 'formik';

import FormikTextField from '../../../../common/components/FormikTextField';

type Props = {
  title: string;
  startIcon?: React.ReactNode;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formik?: FormikProps<any>;
  formikFieldKey?: string;
  isCurrency?: boolean;
} & TextFieldProps;

const OrganizationInput: React.FC<Props> = ({
  title,
  startIcon,
  formik,
  formikFieldKey,
  isCurrency = false,
  ...props
}) => {
  const commonProps: TextFieldProps = React.useMemo(() => {
    return {
      placeholder: title,
      variant: 'outlined',
      sx: {
        ...props.sx,
        [`& fieldset`]: {
          borderRadius: '50px',
        },
      },
      InputProps: {
        ...props.InputProps,
        style: {
          paddingLeft: '20px',
          paddingRight: '20px',
        },
        startAdornment: (
          <InputAdornment position='start'>{startIcon}</InputAdornment>
        ),
      },
    };
  }, [title, props.sx, props.InputProps, startIcon]);

  return (
    <Box className='column'>
      <Typography variant='subtitle2' color='secondary' fontSize={16} mb='8px'>
        {title}
      </Typography>
      {formik && formikFieldKey ? (
        <FormikTextField
          {...props}
          {...commonProps}
          fieldName={formikFieldKey}
          formik={formik}
          isCurrency={isCurrency}
        />
      ) : (
        <TextField {...props} {...commonProps} />
      )}
    </Box>
  );
};

export default OrganizationInput;
